import { createFileRoute, notFound, redirect } from '@tanstack/react-router';

import { versionsQuery, type ProductCode } from '@/features/banks-products';
import { NotFoundView } from '@/features/shell';

const PRODUCTS: readonly string[] = ['PF', 'CC', 'HF', 'SME'];

/** Opens the published version, or the draft when nothing is published yet. */
export const Route = createFileRoute('/_app/banks/$bankId/products/$productId/')({
  loader: async ({ context, params }) => {
    if (!PRODUCTS.includes(params.productId)) throw notFound();
    const versions = await context.queryClient.query({ ...versionsQuery(params.bankId, params.productId as ProductCode), staleTime: 'static' });
    const target = versions.find((v) => v.state === 'published') ?? versions.find((v) => v.state === 'draft') ?? versions[0];
    if (!target) throw notFound();
    throw redirect({ to: '/banks/$bankId/products/$productId/versions/$versionNo', params: { ...params, versionNo: String(target.versionNo) }, replace: true });
  },
  notFoundComponent: function ProductNotFound() {
    const { bankId, productId } = Route.useParams();
    return <NotFoundView reference={`${bankId} · ${productId}`} />;
  },
});
